import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Input, InputGroup, InputGroupAddon, Row } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import styles from '../form.module.scss';

class GarageFilter extends Component {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    var { minGarageSpaces, maxGarageSpaces, tabIndex } = this.props;

    return (
      <Row>
        <Col xs={6}>
          <InputGroup>
            <InputGroupAddon
              tag="label"
              htmlFor="minGarageSpaces"
              addonType="prepend"
              className={styles.inlineInputGroupAddon}
            >
              <FontAwesome name="car" className={BS.inputGroupText} />
            </InputGroupAddon>
            <Input
              {...minGarageSpaces.input}
              placeholder="No Min"
              tabIndex={tabIndex}
              onChange={e => {
                const val = e.target.value;
                minGarageSpaces.input.onChange(val !== '' ? parseInt(val, 0) : val);
              }}
            />
          </InputGroup>
        </Col>
        <Col xs={6}>
          <InputGroup>
            <InputGroupAddon
              tag="label"
              htmlFor="maxGarageSpaces"
              addonType="prepend"
              className={styles.inlineInputGroupAddon}
            >
              <FontAwesome name="car" className={BS.inputGroupText} />
            </InputGroupAddon>
            <Input
              {...maxGarageSpaces.input}
              placeholder="No Max"
              tabIndex={tabIndex ? tabIndex + 1 : tabIndex}
              onChange={e => {
                const val = e.target.value;
                maxGarageSpaces.input.onChange(val !== '' ? parseInt(val, 0) : val);
              }}
            />
          </InputGroup>
        </Col>
      </Row>
    );
  }
}

export default GarageFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/garage-filter.js